import { TesSalaryTableDraftContent } from "../../tesSalaryTables/tesSalaryTablesApi";

export const sanitizeDecimalString = (value?: string | null) => {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? trimmed : null;
};

export const sanitizeDraftContent = (
  content: TesSalaryTableDraftContent,
): TesSalaryTableDraftContent =>
  ({
    ...content,
    monthlyDivider: sanitizeDecimalString(content.monthlyDivider) as any,
    rows: content.rows.map((row, index) => ({
      ...row,
      secondaryLabel: row.secondaryLabel || null,
      sortOrder: index,
    })),
    columns: content.columns.map((column, index) => ({
      ...column,
      secondaryLabel: column.secondaryLabel || null,
      sortOrder: index,
    })),
    cells: content.cells
      .map((cell) => ({
        rowId: cell.rowId,
        columnId: cell.columnId,
        hourlySalary: sanitizeDecimalString(cell.hourlySalary) as any,
        monthlySalary: sanitizeDecimalString(cell.monthlySalary) as any,
      }))
      .filter(
        (cell) => cell.hourlySalary !== null || cell.monthlySalary !== null,
      ) as any,
  }) as TesSalaryTableDraftContent;
